<script setup lang="ts">
import router from '@/router';
import { IonButton } from '@ionic/vue';

export interface Props {
	buttonText?: string;
	text?: string;
	link?: string;
}

const props = withDefaults(defineProps<Props>(), {
	buttonText: 'Text',
	link: '',
	text: 'This is a default value',
});

const goTo = async (link: string) => {
	await router.push(link);
};
</script>

<template>
	<div class="flex justify-evenly items-center sign-in-sign-up-alert-container">
		<span class="font-sourcesanspro-regular text-base text-white">{{ $t(props.text) }}</span>
		<ion-button shape="round" @click="goTo(props.link)" color="primary">
			<span class="font-sourcesanspro-semibold text-base">{{ $t(props.buttonText) }}</span>
		</ion-button>
	</div>
</template>

<style lang="scss" scoped>
.sign-in-sign-up-alert-container {
	ion-button {
		--border-width: 1px;
		height: 34px;

		&::part(native) {
			padding: 0 10px;
		}
	}
}
</style>
